import React from "react";
import { Link } from "react-router-dom";
import "./Web1920153.css";

function Web1920153(props) {
  const { overlapGroup1, backToImage } = props;

  return (
    <div className="container-center-horizontal video">
      <div className="web-1920-153 screen">
        <div className="overlap-group1-14" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-24 border-1px-dove-gray"></div>
          <Link to="/web-1920-101">
            <div className="group-142-7">
              <div className="overlap-group-27">
                <div className="rectangle-33-12 border-3px-picton-blue">
                <div className="back-to-image-5 lato-medium-white-13px">{backToImage}</div>
                </div>
                
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920153;
